// AgentX full page (/agentx) — the same chat as the floating box, with the conversation history as a sidebar.
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AgentXChat from '../../components/agentx/AgentXChat';

export default function AgentXPage() {
  const [params] = useSearchParams();
  return <AgentXChat variant="page" initialSessionId={params.get('c') || null} />;
}
